import { BulkDeleteButton, BulkDeleteButtonProps } from "react-admin";

// Par do AppDeleteButton para a barra de "N selecionados": exclusão em
// massa SEMPRE com modal de confirmação (pessimistic), no lugar do
// padrão excluir-na-hora com "Desfazer" de 4 segundos.
export const AppBulkDeleteButton = (props: BulkDeleteButtonProps) => (
  <BulkDeleteButton
    mutationMode="pessimistic"
    confirmTitle="Excluir os registros selecionados?"
    confirmContent="Esta ação é definitiva e não pode ser desfeita. Confirmar a exclusão?"
    {...props}
  />
);
